import { esNativo } from '../config/entorno';
import { APP_VERSION } from '../config/version';

const BANNER_APK_KEY = 'gastos_apk_banner_oculto';

export function nombreArchivoApk(version = APP_VERSION) {
  return `gastos-app-${version}.apk`;
}

export const RUTA_APK = `/apk/${nombreArchivoApk()}`;

export function esAndroid() {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

export function esPwaStandalone() {
  if (typeof window === 'undefined') return false;
  const modo = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
  const iosStandalone = Boolean(window.navigator && window.navigator.standalone);
  return Boolean(modo || iosStandalone);
}

export function debeMostrarBannerApk(opciones = {}) {
  const nativo = opciones.nativo !== undefined ? opciones.nativo : esNativo();
  const android = opciones.android !== undefined ? opciones.android : esAndroid();
  const standalone = opciones.standalone !== undefined ? opciones.standalone : esPwaStandalone();
  const oculto = opciones.oculto !== undefined ? opciones.oculto : bannerApkOculto();
  return Boolean(android && !nativo && !standalone && !oculto);
}

export function bannerApkOculto() {
  try {
    return localStorage.getItem(BANNER_APK_KEY) === '1';
  } catch {
    return false;
  }
}

export function ocultarBannerApk() {
  try {
    localStorage.setItem(BANNER_APK_KEY, '1');
  } catch {
    /* ignore */
  }
}
